import '../assets/NcUserBubble-COPMjmKa.css';
import { n as s } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { N as n } from "./NcAvatar-BBhoG-za.mjs";
import { N as i } from "./NcPopover--V3R3EKV.mjs";
import o from "vue";
const l = {
  name: "NcUserBubbleDiv"
};
var u = function() {
  var e = this, r = e._self._c;
  return r("div", [e._t("trigger")], 2);
}, p = [], c = /* @__PURE__ */ s(
  l,
  u,
  p,
  !1,
  null,
  null,
  null,
  null
);
const m = c.exports, d = {
  name: "NcUserBubble",
  components: {
    NcAvatar: n,
    NcPopover: i,
    NcUserBubbleDiv: m
  },
  props: {
    /**
     * Override generated avatar, can be an url or an icon class
     */
    avatarImage: {
      type: String,
      default: void 0
    },
    /**
     * Provide the user id if this is a user
     */
    user: {
      type: String,
      default: void 0
    },
    /**
     * Displayed label
     */
    displayName: {
      type: String,
      default: void 0
    },
    /**
     * Whether or not to display the user-status
     */
    showUserStatus: {
      type: Boolean,
      default: !1
    },
    /**
     * Define the whole bubble as a link
     */
    url: {
      type: String,
      default: void 0,
      validator: (t) => {
        var e;
        try {
          return t = new URL(t, (e = t == null ? void 0 : t.startsWith) != null && e.call(t, "/") ? window.location.href : void 0), !0;
        } catch {
          return !1;
        }
      }
    },
    /**
     * Default popover state. Requires the UserBubble
     * to have some content to render inside the popover
     */
    open: {
      type: Boolean,
      default: !1
    },
    /**
     * Use the primary colour
     */
    primary: {
      type: Boolean,
      default: !1
    },
    /**
     * This is the height of the component
     */
    size: {
      type: Number,
      default: 20
    },
    /**
     * This is the margin of the avatar (size - margin = avatar size)
     */
    margin: {
      type: Number,
      default: 2
    }
  },
  emits: [
    "click",
    "update:open"
  ],
  computed: {
    /**
     * If userbubble is empty, let's NOT
     * use the Popover component
     * We need a component instead of a simple div here,
     * because otherwise the trigger template will not be shown.
     *
     * @return {string} 'Popover' or 'UserBubbleDiv'
     */
    isPopoverComponent() {
      return this.popoverEmpty ? "NcUserBubbleDiv" : "NcPopover";
    },
    /**
     * Is the provided avatar url valid or not
     *
     * @return {boolean}
     */
    isAvatarUrl() {
      if (!this.avatarImage)
        return !1;
      try {
        return !!new URL(this.avatarImage);
      } catch {
        return !1;
      }
    },
    /**
     * Do we have a custom avatar or not
     *
     * @return {boolean}
     */
    isCustomAvatar() {
      return !!this.avatarImage;
    },
    hasUrl() {
      return this.url && this.url.trim() !== "";
    },
    isLinkComponent() {
      return this.hasUrl ? "a" : "div";
    },
    popoverEmpty() {
      return !("default" in this.$slots);
    },
    styles() {
      return {
        content: {
          height: this.size + "px",
          lineHeight: this.size + "px",
          borderRadius: this.size / 2 + "px"
        },
        avatar: {
          marginLeft: this.margin + "px"
        }
      };
    }
  },
  mounted() {
    !this.displayName && !this.user && o.util.warn("[NcUserBubble] At least `displayName` or `user` property should be set.");
  },
  methods: {
    onOpenChange(t) {
      this.$emit("update:open", t);
    },
    /**
     * Catch and forward click event to parent
     *
     * @param {Event} event the click event
     */
    onClick(t) {
      this.$emit("click", t);
    }
  }
};
var f = function() {
  var e = this, r = e._self._c;
  return r(e.isPopoverComponent, { tag: "component", staticClass: "user-bubble__wrapper", attrs: { trigger: "hover focus", shown: e.open }, on: { "update:open": e.onOpenChange }, scopedSlots: e._u([{ key: "trigger", fn: function({ attrs: a }) {
    return [r(e.isLinkComponent, e._b({ tag: "component", staticClass: "user-bubble__content", class: { "user-bubble__content--primary": e.primary }, style: e.styles.content, attrs: { href: e.hasUrl ? e.url : null }, on: { click: e.onClick } }, "component", a, !1), [r("NcAvatar", { staticClass: "user-bubble__avatar", style: e.styles.avatar, attrs: { url: e.isCustomAvatar && e.isAvatarUrl ? e.avatarImage : void 0, "icon-class": e.isCustomAvatar && !e.isAvatarUrl ? e.avatarImage : void 0, user: e.user, "display-name": e.displayName, size: e.size - e.margin * 2, "disable-tooltip": !0, "disable-menu": !0, "show-user-status": e.showUserStatus } }), r("span", { staticClass: "user-bubble__name" }, [e._v(" " + e._s(e.displayName || e.user) + " ")]), e.$slots.name ? r("span", { staticClass: "user-bubble__secondary" }, [e._t("name")], 2) : e._e()], 1)];
  } }], null, !0) }, [e._t("default")], 2);
}, _ = [], v = /* @__PURE__ */ s(
  d,
  f,
  _,
  !1,
  null,
  "8f0fbaf1",
  null,
  null
);
const N = v.exports;
export {
  N
};
